
/* ============ PRODUCT SVG ============ */
function productSVG(){return `
<svg class="pv-svg" viewBox="0 -132 460 764" xmlns="http://www.w3.org/2000/svg" aria-label="ClovaPet automatisch kippenluik">
  <defs>
    <linearGradient id="pnl" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stop-color="#26292D"/><stop offset=".5" stop-color="#2F3338"/><stop offset="1" stop-color="#24272B"/>
    </linearGradient>
    <linearGradient id="barg" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#1D2023"/><stop offset="1" stop-color="#141618"/>
    </linearGradient>
  </defs>
  <g class="pv-back">
    <rect x="64" y="112" width="332" height="478" rx="16" fill="#24272B" stroke="#101215"/>
    <rect x="76" y="96" width="26" height="42" rx="5" fill="#AEB4B9"/><circle cx="89" cy="108" r="3" fill="#7A8085"/>
    <rect x="358" y="96" width="26" height="42" rx="5" fill="#AEB4B9"/><circle cx="371" cy="108" r="3" fill="#7A8085"/>
    <rect x="88" y="140" width="284" height="426" rx="10" fill="#2A2E32"/>
    <g fill="#D7DADC" opacity=".5">
      ${Array.from({length:20},(_,i)=>`<rect x="226" y="${170+i*19}" width="8" height="8" rx="2"/>`).join('')}
    </g>
    <circle cx="344" cy="172" r="6" fill="#101215"/>
  </g>
  <g class="pv-front">
    <rect x="84" y="206" width="28" height="384" rx="6" fill="#26292B" stroke="#1A1D20"/>
    <rect x="348" y="206" width="28" height="384" rx="6" fill="#26292B" stroke="#1A1D20"/>
    <rect x="84" y="572" width="292" height="18" rx="6" fill="#26292B" stroke="#1A1D20"/>
    <rect x="112" y="206" width="236" height="368" fill="#0F1216"/>
    ${[[98,250],[98,392],[98,534],[362,250],[362,392],[362,534]].map(([x,y])=>`
      <circle cx="${x}" cy="${y}" r="5" fill="#191C1F" stroke="#0E1012"/>
      <path d="M${x-2.6} ${y}h5.2M${x} ${y-2.6}v5.2" stroke="#3E434A" stroke-width="1.2"/>`).join('')}
    <g class="pv-panel">
      <rect class="pv-paneltint" x="104" y="-58" width="252" height="380" rx="10" fill="url(#pnl)" stroke="#111417"/>
      <rect x="118" y="-44" width="224" height="352" rx="7" fill="none" stroke="#1E2226" stroke-width="2"/>
      <g fill="#E8EAEA" opacity=".92">
        ${Array.from({length:19},(_,i)=>`<rect x="226" y="${-30+i*18}" width="8" height="8" rx="2"/>`).join('')}
      </g>
      <rect x="200" y="292" width="60" height="9" rx="4.5" fill="rgba(238,240,241,.9)"/>
    </g>
    <g class="pv-unit">
      <rect x="58" y="118" width="344" height="94" rx="14" fill="url(#barg)" stroke="#0B0D0E"/>
      <rect x="60" y="120" width="340" height="3" rx="1.5" fill="#2B2F34"/>
      <text x="88" y="137" font-family="Raleway,sans-serif" font-size="9.5" font-weight="600" letter-spacing="3.5" fill="#7C838A">CLOVAPET</text>
      <circle class="pv-sensorglow" cx="196" cy="133" r="13" fill="#E8C97F" opacity="0" style="filter:blur(4px)"/>
      <circle class="pv-sensor" cx="196" cy="133" r="4" fill="#0B0D0E" stroke="#2E3438" stroke-width="1.5"/>
      <circle class="pv-led" cx="182" cy="133" r="3" fill="#7FB77E"/>
      <g class="pv-lcd">
        <rect x="84" y="144" width="120" height="58" rx="6" fill="#C7D2D0" stroke="#0D0F10"/>
        <text x="92" y="158" font-family="'Nunito Sans',sans-serif" font-size="8" font-weight="700" fill="#5A6563">TIME:</text>
        <text class="pv-clock" x="196" y="160" text-anchor="end" font-family="'Nunito Sans',sans-serif" font-size="14" font-weight="800" fill="#22282B">07:30</text>
        <text x="92" y="176" font-family="'Nunito Sans',sans-serif" font-size="8" font-weight="700" fill="#5A6563">OPEN:</text>
        <text x="196" y="177" text-anchor="end" font-family="'Nunito Sans',sans-serif" font-size="11.5" font-weight="800" fill="#22282B">07:30</text>
        <text x="92" y="194" font-family="'Nunito Sans',sans-serif" font-size="8" font-weight="700" fill="#5A6563">CLOSE:</text>
        <text x="196" y="195" text-anchor="end" font-family="'Nunito Sans',sans-serif" font-size="11.5" font-weight="800" fill="#22282B">22:10</text>
      </g>
      <g stroke="#0F1113">
        <circle cx="226" cy="152" r="9" fill="#24282C"/><path d="M226 148l4 6h-8z" fill="#8A9096" stroke="none"/>
        <circle cx="226" cy="176" r="9" fill="#24282C"/><path d="M226 180l-4-6h8z" fill="#8A9096" stroke="none"/>
        <circle cx="226" cy="200" r="9" fill="#24282C"/><circle cx="226" cy="200" r="4" fill="none" stroke="#8A9096" stroke-width="1.6" stroke-dasharray="2 1.6"/>
      </g>
      <g fill="#2E3338">
        <rect x="248" y="146" width="60" height="4" rx="2"/><rect x="248" y="155" width="42" height="3" rx="1.5"/>
        <rect x="248" y="170" width="60" height="4" rx="2"/><rect x="248" y="179" width="42" height="3" rx="1.5"/>
        <rect x="248" y="194" width="60" height="4" rx="2"/><rect x="248" y="203" width="42" height="3" rx="1.5"/>
      </g>
      <circle cx="352" cy="165" r="46" fill="#1D2023" stroke="#0C0E10" stroke-width="3"/>
      <circle cx="352" cy="165" r="37" fill="#17191B"/>
      <rect x="316" y="156" width="72" height="18" rx="9" fill="#26292D" stroke="#0F1113"/>
      <path d="M312 143l6 3-6 3z" fill="#3E434A"/>
    </g>
  </g>
</svg>`}

function stepDoor(options={}){
  const A=window.CP_ASSETS||{};
  const hero=!!options.hero,showBack=options.back!==false;
  return `<div class="pv-photo pv-step-door${hero?' is-hero':''}" role="img" aria-label="ClovaPet automatisch kippenluik">
    <div class="pv-frontgrp">
      <div class="pv-step-aperture" aria-hidden="true"></div>
      <img class="pv-step-panel" src="${A.stepPanel||A.panel||'cp-step-front-panel.webp'}" width="1200" height="1600" alt="" aria-hidden="true">
      <img class="pv-step-static" src="${A.stepStatic||A.frame||'cp-step-front-static.webp'}" width="1200" height="1600" alt=""${hero?' fetchpriority="high"':''}>
      <img class="pv-step-controls" src="${A.bar||'cp-door-bar.webp'}" width="591" height="170" alt="" aria-hidden="true">
      <div class="pv-sensorglow"></div>
    </div>
    ${showBack?`<img class="pv-back" src="${A.stepBack||A.back||'cp-step-back.webp'}" width="1200" height="1600" alt="Achterzijde van het ClovaPet kippenluik">`:''}
  </div>`;
}
function photoDoor(){return stepDoor({back:true})}
function heroDoor(){return stepDoor({hero:true,back:false})}
const hp=document.getElementById('heroProduct');if(hp)hp.innerHTML=heroDoor();
const sp=document.getElementById('storyProduct');if(sp)sp.innerHTML=photoDoor();

/* ============ HERO SCRUB: de avond valt (met smoothing) ============ */
(function(){
  const sec=document.getElementById('heroScroll'),pin=document.getElementById('heroPin');
  if(!sec||!pin)return;
  const pageWrapper=document.querySelector('.page-wrapper');
  const scrollRoot=pageWrapper&&pageWrapper.scrollHeight>pageWrapper.clientHeight+1?pageWrapper:null;
  const scrollTarget=scrollRoot||window;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const heroPanel=document.querySelector('#heroProduct .pv-step-panel');
  const heroFront=document.querySelector('#heroProduct .pv-frontgrp');
  const sPeriod=document.getElementById('statusPeriod'),sLabel=document.getElementById('statusLabel');
  const shoot=document.getElementById('shootStar');
  const stars=document.getElementById('skyStars'),flies=document.getElementById('fireflies');
  if(stars)for(let i=0;i<28;i++){const st=document.createElement('i');
    st.style.left=Math.random()*100+'%';st.style.top=Math.random()*62+'%';
    const sz=(1+Math.random()*1.9);st.style.width=st.style.height=sz+'px';
    st.style.setProperty('--twd',(2.5+Math.random()*4).toFixed(1)+'s');
    st.style.setProperty('--twdel',(-Math.random()*6).toFixed(1)+'s');
    stars.appendChild(st);}
  if(flies)for(let i=0;i<9;i++){const f=document.createElement('i');
    f.style.left=(5+Math.random()*90)+'%';f.style.top=(20+Math.random()*75)+'%';
    f.style.setProperty('--fx',(7+Math.random()*7).toFixed(1)+'s');
    f.style.setProperty('--fy',(6+Math.random()*6).toFixed(1)+'s');
    f.style.setProperty('--fd',(-Math.random()*10).toFixed(1)+'s');
    flies.appendChild(f);}
  /* STEP-model: 240.5 mm slag over een totale renderhoogte van 329.5 mm. */
  const OPEN_TRAVEL=72.99;
  let lastShoot=0,lastNight=null;
  function apply(p){
    pin.style.setProperty('--p',p.toFixed(4));
    if(heroPanel)heroPanel.style.transform='translate3d(0,'+(-OPEN_TRAVEL*(1-p)).toFixed(3)+'%,0)';
    if(heroFront)heroFront.style.transform='translate3d(0,'+(OPEN_TRAVEL*.5*(1-p)).toFixed(3)+'%,0)';
    const dusk=Math.sin(Math.min(1,Math.max(0,p))*Math.PI);
    pin.style.setProperty('--seamo',(dusk*.9).toFixed(3));
    const night=p>.55;
    pin.classList.toggle('is-night',night);
    pin.classList.toggle('locked',p>.965);
    if(sPeriod&&night!==lastNight){
      sPeriod.setAttribute('aria-label',night?sPeriod.dataset.nightLabel:sPeriod.dataset.dayLabel);
      lastNight=night;
    }
    if(sLabel)sLabel.textContent=p>.965?'Luik vergrendeld':night?'Luik sluit\u2026':'Luik geopend';
    if(shoot&&p>.8&&Date.now()-lastShoot>12000){lastShoot=Date.now();
      shoot.classList.remove('go');void shoot.offsetWidth;shoot.classList.add('go');}
  }
  if(reduce){apply(0);return;}
  let target=0,cur=-1,last=performance.now();
  function readTarget(){
    const total=sec.offsetHeight-innerHeight;
    target=Math.min(1,Math.max(0,-sec.getBoundingClientRect().top/total));
  }
  function loop(now){
    const dt=Math.min(.05,(now-last)/1000);last=now;
    if(cur<0)cur=target;
    else if(Math.abs(target-cur)>0.0006){cur+=(target-cur)*Math.min(1,dt*9);if(Math.abs(target-cur)<0.0006)cur=target;apply(cur)}
    requestAnimationFrame(loop);
  }
  scrollTarget.addEventListener('scroll',readTarget,{passive:true});
  addEventListener('resize',readTarget);
  readTarget();apply(target);cur=target;requestAnimationFrame(loop);
})();

/* ============ HEADER & REVEAL ============ */
const hdr=document.getElementById('siteHeader');
if(hdr)addEventListener('scroll',()=>hdr.classList.toggle('scrolled',scrollY>40),{passive:true});
const ro=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');ro.unobserve(e.target)}}),{threshold:.15});
document.querySelectorAll('.reveal').forEach(el=>ro.observe(el));

/* ============ PRODUCTLINK ============ */
const S=k=>(window.CP_SETTINGS&&CP_SETTINGS[k])||null;
if(S('shop_url'))document.querySelectorAll('.js-shop-link').forEach(a=>a.href=S('shop_url'));

/* ============ STORY ============ */
const story=document.getElementById('story');
const so=new IntersectionObserver(es=>{
  es.forEach(e=>{
    if(e.isIntersecting){
      const s=+e.target.dataset.step;
      story.className='story step-'+s+(e.target.dataset.night?' night':'');
    }
  });
},{rootMargin:'-45% 0px -45% 0px'});
document.querySelectorAll('.story-step').forEach(el=>so.observe(el));
/* sneeuw */
const snow=document.getElementById('snow');
for(let i=0;i<34;i++){
  const f=document.createElement('i');
  f.style.left=Math.random()*100+'%';
  f.style.animationDuration=(7+Math.random()*8)+'s';
  f.style.animationDelay=(-Math.random()*12)+'s';
  f.style.opacity=.25+Math.random()*.5;
  f.style.width=f.style.height=(2.5+Math.random()*3)+'px';
  snow.appendChild(f);
}

/* ============ SEIZOENEN ============ */
document.querySelectorAll('.season-tab').forEach(t=>t.addEventListener('click',()=>{
  document.querySelectorAll('.season-tab').forEach(x=>{const on=x===t;x.classList.toggle('active',on);x.setAttribute('aria-selected',on)});
  document.querySelectorAll('.season-slide').forEach(sl=>sl.classList.toggle('active',sl.dataset.season===t.dataset.season));
}));

document.querySelectorAll('#cp-home a[href^="#"]').forEach(a=>{
  a.addEventListener('click',e=>{
    const t=document.querySelector(a.getAttribute('href'));
    if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}
  });
});

/* ============ PRODUCTPAGINA (Shopify) ============ */
(function(){
  const buy=document.querySelector('#cp-home .pdp-hero');
  if(!buy)return;
  /* galerij */
  const stage=document.getElementById('pdpStage');
  document.querySelectorAll('#cp-home .pdp-thumb').forEach(t=>t.addEventListener('click',()=>{
    document.querySelectorAll('#cp-home .pdp-thumb').forEach(x=>x.classList.toggle('active',x===t));
    stage.innerHTML='<img class="stage-img" src="'+t.dataset.src+'" alt="">';bindZoom();
  }));
  function bindZoom(){
    const img=stage.querySelector('.stage-img');if(!img)return;
    stage.onmousemove=e=>{const r=stage.getBoundingClientRect();
      img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%'};
    stage.onmouseenter=()=>stage.classList.add('zooming');
    stage.onmouseleave=()=>stage.classList.remove('zooming');
  }
  bindZoom();
  /* varianten (echte form) */
  const idInput=document.getElementById('pdpVariantId');
  document.querySelectorAll('#cp-home .pdp-variant').forEach(b=>b.addEventListener('click',()=>{
    document.querySelectorAll('#cp-home .pdp-variant').forEach(x=>x.classList.toggle('active',x===b));
    if(idInput)idInput.value=b.dataset.id;
    const pr=document.getElementById('pdpPrice'),sp=document.getElementById('stickyPrice');
    if(pr)pr.textContent=b.dataset.price;if(sp)sp.textContent=b.dataset.price;
  }));
  /* aantal */
  const qv=document.getElementById('qtyVal');
  document.querySelectorAll('#cp-home [data-qty]').forEach(b=>b.addEventListener('click',()=>{
    qv.value=Math.min(9,Math.max(1,(+qv.value||1)+(+b.dataset.qty)));
  }));
  /* sticky */
  const sticky=document.getElementById('pdpSticky');
  if(sticky){addEventListener('scroll',()=>{
    const past=buy.getBoundingClientRect().bottom<0;
    const cta=document.querySelector('#cp-home .pdp-cta');
    const nearEnd=cta?cta.getBoundingClientRect().top<innerHeight:false;
    sticky.classList.toggle('show',past&&!nearEnd);
  },{passive:true})}
})();
(function(){
  /* oplossing + hotspots-product */
  document.querySelectorAll('.cp-solution-product,.cp-xp-product').forEach(el=>{if(el&&typeof photoDoor==='function')el.innerHTML=photoDoor()});
  const st=document.querySelector('#cp-home .cp-xp-stage');
  if(st){
    document.querySelectorAll('#cp-home .hotspot').forEach(h=>{
      const open=()=>{
        document.querySelectorAll('#cp-home .xp-tip').forEach(t=>t.classList.remove('show'));
        document.querySelectorAll('#cp-home .hotspot').forEach(x=>x.classList.remove('active'));
        const tip=document.getElementById(h.dataset.tip);if(!tip)return;
        h.classList.add('active');
        const hx=parseFloat(h.style.left), hy=parseFloat(h.style.top);
        tip.style.left=hx>55?'auto':('calc('+hx+'% + 40px)');
        tip.style.right=hx>55?('calc('+(100-hx)+'% + 40px)'):'auto';
        tip.style.top='calc('+Math.min(hy,70)+'% - 10px)';
        tip.classList.add('show');
      };
      h.addEventListener('mouseenter',open);h.addEventListener('click',open);
    });
    st.addEventListener('mouseleave',()=>{document.querySelectorAll('#cp-home .xp-tip').forEach(t=>t.classList.remove('show'));document.querySelectorAll('#cp-home .hotspot').forEach(x=>x.classList.remove('active'))});
    addEventListener('scroll',()=>{
      const r=st.getBoundingClientRect();
      if(r.top<innerHeight&&r.bottom>0){const p=1-(r.top+r.height/2)/innerHeight;
        st.style.transform='perspective(900px) rotateY('+((p-.5)*7)+'deg)';}
    },{passive:true});
  }
  /* faq */
  document.querySelectorAll('#cp-home .faq-q').forEach(q=>q.addEventListener('click',()=>{
    const item=q.parentElement,a=item.querySelector('.faq-a'),open=item.classList.contains('open');
    document.querySelectorAll('#cp-home .faq-item.open').forEach(o=>{o.classList.remove('open');o.querySelector('.faq-a').style.maxHeight='0'});
    if(!open){item.classList.add('open');a.style.maxHeight=a.scrollHeight+'px'}
  }));
  const fs=document.querySelector('#cp-home .cp-faq-search');
  if(fs)fs.addEventListener('input',e=>{
    const q=e.target.value.toLowerCase();
    document.querySelectorAll('#cp-home .faq-item').forEach(it=>{it.style.display=it.textContent.toLowerCase().includes(q)?'':'none'});
  });
})();
